import * as React from 'react';
import {StyleProp, ViewStyle} from 'react-native';

interface IProps {
  width?: number;
  style?: StyleProp<ViewStyle> | React.CSSProperties;
}

export default (props: IProps) => {
  const {width: size, style} = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style as React.CSSProperties}>
      <circle cx="17.5" cy="17.5" r="17.5" fill="#0088FF" />
      <path
        d="M15.5 11.75V13H20.5V11.75C20.5 11.6125 20.3875 11.5 20.25 11.5H15.75C15.6125 11.5 15.5 11.6125 15.5 11.75ZM14 13V11.75C14 10.7844 14.7844 10 15.75 10H20.25C21.2156 10 22 10.7844 22 11.75V13V14V25H14V14V13ZM12 13H13V25H12C10.8969 25 10 24.1031 10 23V15C10 13.8969 10.8969 13 12 13ZM24 25H23V13H24C25.1031 13 26 13.8969 26 15V23C26 24.1031 25.1031 25 24 25Z"
        fill="white"
      />
    </svg>
  );
};
